export const WIDGET_CSS = `
:host {
  position: fixed;
  z-index: 2147483647;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #111827;
  display: flex;
  flex-direction: column;
}

:host([data-position="bottom-right"]) {
  right: 16px;
  bottom: 16px;
  align-items: flex-end;
}

:host([data-position="bottom-left"]) {
  left: 16px;
  bottom: 16px;
  align-items: flex-start;
}

:host([data-position="top-right"]) {
  right: 16px;
  top: 16px;
  align-items: flex-end;
}

:host([data-position="top-left"]) {
  left: 16px;
  top: 16px;
  align-items: flex-start;
}

* {
  box-sizing: border-box;
}

:host { --aa-acc:#aefc63; --aa-acc-bg:#eefadf; }
.aa-assist-launcher {
  position:relative;overflow:visible;
  width:52px;height:52px;border:0;border-radius:14px;background:var(--aa-acc);color:#1d1b18;cursor:grab;
  display:flex;align-items:center;justify-content:center;box-shadow:0 12px 26px rgba(174,252,99,.44);
  touch-action:none;-webkit-user-select:none;user-select:none;
  transition:transform .18s cubic-bezier(.16,1,.3,1);
}
.aa-assist-launcher-dismiss {
  position:absolute;top:-6px;right:-6px;width:20px;height:20px;border-radius:50%;
  background:#1d1b18;color:#fff;display:flex;align-items:center;justify-content:center;
  border:2px solid var(--aa-acc);box-shadow:0 2px 6px rgba(0,0,0,.32);cursor:pointer;
  opacity:0;transform:scale(.6);transition:opacity .15s,transform .15s;
}
.aa-assist-launcher:hover .aa-assist-launcher-dismiss,
.aa-assist-launcher:focus-within .aa-assist-launcher-dismiss { opacity:1;transform:scale(1); }
.aa-assist-launcher-dismiss svg { width:11px;height:11px;display:block; }
.aa-assist-launcher:hover { transform:scale(1.07); }
.aa-assist-launcher:active { cursor:grabbing; transform:scale(.96); }
.aa-assist-launcher svg { transition:transform .3s cubic-bezier(.16,1,.3,1); }
.aa-assist-launcher:hover svg { transform:rotate(-8deg); }
@media (prefers-reduced-motion: no-preference) {
  .aa-assist-launcher { animation:aa-pulse 2.8s ease-in-out infinite; }
}
@keyframes aa-pulse {
  0%,100% { box-shadow:0 12px 26px rgba(174,252,99,.44), 0 0 0 0 rgba(174,252,99,.5); }
  55% { box-shadow:0 12px 26px rgba(174,252,99,.44), 0 0 0 13px rgba(174,252,99,0); }
}
.aa-assist-launcher svg,.aa-assist-close svg,.aa-assist-control svg,.aa-assist-header-badge svg { display:block; }
.aa-assist-launcher:focus-visible,.aa-assist-control:focus-visible,.aa-assist-clear:focus-visible,
.aa-assist-close:focus-visible,.aa-assist-structure-item:focus-visible { outline:3px solid #111827; outline-offset:3px; }
/* The panel is a viewport-anchored drawer pinned to the RIGHT edge, full
   height — independent of where the (draggable) launcher sits. position:fixed
   inside the shadow root is viewport-relative, so the launcher can live in any
   corner and the panel always opens on the right. Header sticks to the top and
   the footer sticks to the bottom while the controls scroll between them. */
.aa-assist-panel {
  position:fixed;top:0;right:0;bottom:0;
  width:min(420px,100vw);
  height:100vh;height:100dvh;
  max-height:100vh;max-height:100dvh;
  margin:0;overflow:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;
  background:#fff;color:#111827;border:0;border-left:1px solid #e6e7eb;border-radius:0;
  box-shadow:-20px 0 50px rgba(17,24,39,.18);
  scrollbar-width:thin;scrollbar-color:#c8cdd4 transparent;
}
.aa-assist-panel::-webkit-scrollbar{width:10px;}
.aa-assist-panel::-webkit-scrollbar-track{background:transparent;}
.aa-assist-panel::-webkit-scrollbar-thumb{background:#d2d6dc;border-radius:100px;border:3px solid transparent;background-clip:padding-box;}
.aa-assist-panel::-webkit-scrollbar-thumb:hover{background:#aab0b9;background-clip:padding-box;}
@media (prefers-reduced-motion: no-preference) {
  .aa-assist-panel { animation:aa-assist-drawer-in .22s ease; }
}
@keyframes aa-assist-drawer-in { from { transform:translateX(24px);opacity:0; } to { transform:none;opacity:1; } }
/* Hide the launcher while the drawer is open — the drawer header owns the close control. */
:host([data-open="true"]) .aa-assist-launcher { display:none; }
.aa-assist-header { position:sticky;top:0;z-index:2;background:#fff;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 18px;border-bottom:1px solid #f0f1f4; }
.aa-assist-header-left { display:flex;align-items:center;gap:10px; }
.aa-assist-header-badge { width:30px;height:30px;border-radius:8px;background:var(--aa-acc);color:#1d1b18;display:flex;align-items:center;justify-content:center; }
.aa-assist-title { margin:0;font-size:16px;line-height:1.25;font-weight:700; }
.aa-assist-close { width:32px;height:32px;border:1px solid #e6e7eb;border-radius:8px;background:#fff;color:#6b7280;cursor:pointer;display:flex;align-items:center;justify-content:center; }
.aa-assist-body { padding:14px 18px 18px; }
.aa-assist-section { margin-top:14px; }
.aa-assist-section:first-of-type { margin-top:2px; }
.aa-assist-section-title { margin:0 0 9px;font-size:11px;letter-spacing:.07em;text-transform:uppercase;font-weight:700;color:#9097a1; }
.aa-assist-grid { display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px; }
.aa-assist-control {
  min-height:90px;border:1px solid #e9ebee;border-radius:14px;background:#fff;color:#111827;cursor:pointer;
  display:flex;flex-direction:column;justify-content:space-between;gap:11px;padding:13px 13px;font:inherit;text-align:left;
  transition:border-color .16s, background .16s, transform .16s cubic-bezier(.16,1,.3,1), box-shadow .16s;
}
.aa-assist-control:hover { border-color:var(--aa-acc);background:#fbfef6;transform:translateY(-2px);box-shadow:0 6px 16px rgba(17,24,39,.07); }
.aa-assist-control-top { display:flex;align-items:center;justify-content:space-between; }
.aa-assist-control-chip { width:34px;height:34px;border-radius:11px;background:var(--aa-acc-bg);color:#2f5209;display:flex;align-items:center;justify-content:center;flex:none;transition:transform .18s cubic-bezier(.16,1,.3,1); }
.aa-assist-control:hover .aa-assist-control-chip { transform:scale(1.08) rotate(-3deg); }
.aa-assist-control-value { font-size:10px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#8a9098;background:#f2f4f6;border-radius:999px;padding:3px 9px; }
.aa-assist-control-label { font-size:13.5px;line-height:1.25;font-weight:600; }
.aa-assist-control[aria-pressed="true"] { border-color:var(--aa-acc);background:#eefadf;box-shadow:inset 0 0 0 1px var(--aa-acc), 0 5px 16px rgba(174,252,99,.30); }
.aa-assist-control[aria-pressed="true"] .aa-assist-control-chip { background:var(--aa-acc);color:#12210a; }
.aa-assist-control[aria-pressed="true"] .aa-assist-control-value { background:var(--aa-acc);color:#12210a; }
.aa-assist-footer { position:sticky;bottom:0;z-index:2;background:linear-gradient(#fff,#fff 60%,rgba(255,255,255,0));background:#fff;display:flex;justify-content:stretch;gap:8px;padding:14px 18px 16px;border-top:1px solid #f0f1f4; }
.aa-assist-clear { width:100%;min-height:46px;border:1px solid var(--aa-acc);border-radius:12px;background:var(--aa-acc-bg);color:#2f5209;cursor:pointer;font:inherit;font-weight:700;font-size:13.5px;letter-spacing:.01em;padding:0 16px;display:flex;align-items:center;justify-content:center;gap:8px;transition:background .16s, color .16s, transform .16s, box-shadow .16s; }
.aa-assist-clear:hover { background:var(--aa-acc);color:#12210a;transform:translateY(-1px);box-shadow:0 6px 18px rgba(174,252,99,.42); }
.aa-assist-clear:active { transform:translateY(0); }
.aa-assist-structure { margin:10px 18px 0;padding:10px;border:1px solid #e6e7eb;border-radius:12px;background:#fff; }
.aa-assist-structure-group + .aa-assist-structure-group { margin-top:10px; }
.aa-assist-structure-title { margin:0 0 6px;font-size:12px;font-weight:700;color:#374151; }
.aa-assist-structure-list { display:grid;gap:4px; }
.aa-assist-structure-item { min-height:32px;border:1px solid #e6e7eb;border-radius:8px;background:#fff;color:#111827;cursor:pointer;font:inherit;font-size:12px;padding:6px 8px;text-align:left; }
@media (prefers-reduced-motion: reduce) { .aa-assist-launcher,.aa-assist-control,.aa-assist-close { transition:none !important; } }

/* Mobile: the panel takes the whole viewport and scrolls internally.
   A bottom-anchored panel can never fit a tall control grid on a phone,
   so on narrow screens it becomes a full-screen scrollable sheet. */
@media (max-width: 560px) {
  .aa-assist-panel {
    position: fixed;
    inset: 0;
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    margin: 0;
    border: 0;
    border-radius: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .aa-assist-header {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
  }
}
`;

export const PAGE_EFFECT_CSS = `
body.aa-assist-large-cursor,
body.aa-assist-large-cursor *:not(#aa-assist-root):not(#aa-assist-root *) {
  cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'%3E%3Cpath d='M8 5v35l9-9 6 13 8-4-6-12h13z' fill='%23111827' stroke='%23ffffff' stroke-width='3' stroke-linejoin='round'/%3E%3C/svg%3E") 8 5, auto !important;
}

body.aa-assist-hide-images img:not(#aa-assist-root img),
body.aa-assist-hide-images picture:not(#aa-assist-root picture),
body.aa-assist-hide-images svg:not(#aa-assist-root svg),
body.aa-assist-hide-images video:not(#aa-assist-root video) {
  visibility: hidden !important;
}

body.aa-assist-highlight-links a:not(#aa-assist-root a) {
  outline: 2px solid #4147ea !important;
  outline-offset: 2px !important;
  text-decoration: underline !important;
  text-decoration-thickness: 0.14em !important;
}

body.aa-assist-reading-mode *:not(#aa-assist-root):not(#aa-assist-root *) {
  background: #fff !important;
  color: #111827 !important;
  font-family: Georgia, "Times New Roman", serif !important;
}

body.aa-assist-reading-mode nav:not(#aa-assist-root nav),
body.aa-assist-reading-mode aside:not(#aa-assist-root aside),
body.aa-assist-reading-mode [role="dialog"]:not(#aa-assist-root [role="dialog"]),
body.aa-assist-reading-mode [role="alertdialog"]:not(#aa-assist-root [role="alertdialog"]),
body.aa-assist-reading-mode [class*="popup" i]:not(#aa-assist-root [class*="popup" i]),
body.aa-assist-reading-mode [class*="modal" i]:not(#aa-assist-root [class*="modal" i]),
body.aa-assist-reading-mode [class*="background-video" i]:not(#aa-assist-root [class*="background-video" i]) {
  display: none !important;
}

body.aa-assist-reading-mode main:not(#aa-assist-root main),
body.aa-assist-reading-mode article:not(#aa-assist-root article),
body.aa-assist-reading-mode p:not(#aa-assist-root p),
body.aa-assist-reading-mode li:not(#aa-assist-root li) {
  max-width: 72ch !important;
}

body.aa-assist-highlight-focus *:not(#aa-assist-root):not(#aa-assist-root *):focus {
  outline: 4px solid #f59e0b !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.28), 0 0 0 12px rgba(17, 24, 39, 0.18) !important;
  background-color: #fffbeb !important;
}

body.aa-assist-dyslexia-font *:not(#aa-assist-root):not(#aa-assist-root *) {
  font-family: Verdana, Tahoma, sans-serif !important;
}

body.aa-assist-readable-font *:not(#aa-assist-root):not(#aa-assist-root *) {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
}

.aa-assist-bionic-prefix {
  font-weight: 800;
}
`;
